import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { CheckboxRenderer } from "../../../../../controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "../../../../../controls/buttons/GridButtonsV2";
import type { CatalogElement } from "../../../models/CatalogElement";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  elements: CatalogElement[] | null;
  setElement: (element: CatalogElement) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  elements,
  setElement,
  setShowModal,
  showContextMenu,
}: Props) => {
  const rows: CatalogElement[] =
    elements?.map((element) => ({
      ...element,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      field: "ElementName",
      headerName: "Name",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Decimals",
      headerName: "Decimals",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Order",
      headerName: "Order",
      minWidth: 20,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "IsActive",
      headerName: "Enabled",
      minWidth: 20,
      flex: 1,
      cellRenderer: CheckboxRenderer,
      cellStyle: cellStyle,
    },
    {
      field: "-",
      cellRenderer: GridButtonsV2,
      cellRendererParams: (params: ICellRendererParams) => ({
        setData: setElement,
        data: params.data as CatalogElement,
        del: false,
        setShowModal: setShowModal,
        showContextMenu: () =>
          showContextMenu(event, params.data, "elementContext"),
      }),
      wrapText: false,
      autoHeight: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      minWidth: 330,
      filter: false,
      autoHeaderHeight: true,
    },
  ];

  return { rows, columnDefs };
};
